// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { useMutation, useQuery } from "@apollo/client";
import { CCard, CCardBody, CCardHeader, CCardTitle, CSmartTable } from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DeleteButton from "../../../components/UI/DeleteButton";
import { DELETE_ID_DEFINITION, LIST_LINKING_ID } from "../../../graphql/queries/linked-id";
import DynamicLinkDefinitionModal from "./Components/DynamicLinkDefinitionModal";

const ManageDynamicLinks = () => {
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const limit = 20;
  const {
    data: {
      LinkingIDDefinitionList: { entries, totalCount },
    } = {
      LinkingIDDefinitionList: {
        entries: [],
        totalCount: 0,
      },
    },
    loading,
    refetch,
  } = useQuery(LIST_LINKING_ID, {
    variables: {
      page,
      limit,
    },
  });

  const [deleteDefinition, { loading: deleteLoading }] = useMutation(DELETE_ID_DEFINITION);

  useEffect(() => {
    let p = 1;
    if (totalCount > 0) {
      p = Math.ceil(totalCount / limit);
      if (p < 1) {
        p = 1;
      }
    }
    setPages(p);
  }, [totalCount]);

  const columns = [
    "name",
    "slug",
    {
      key: "actions",
      _style: {
        maxWidth: "15rem",
      },
    },
  ];

  return (
    <>
      <CCard>
        <CCardHeader>
          <CCardTitle>Manage Dynamic IDs</CCardTitle>
        </CCardHeader>
        <CCardBody>
          <DynamicLinkDefinitionModal onComplete={() => void refetch()} />
        </CCardBody>
        <CSmartTable
          loading={loading}
          columns={columns}
          items={entries}
          pagination={pages > 1}
          paginationProps={{
            activePage: page,
            onActivePageChange: setPage,
            pages,
          }}
          scopedColumns={{
            name: (item) => (
              <td>
                <Link to={`view/${item.id}`}>{item.name}</Link>
              </td>
            ),
            actions: (item) => (
              <td>
                <DeleteButton
                  title={"Delete Link Definition"}
                  onDelete={() =>
                    void deleteDefinition({ variables: { id: item.id } }).then(() => void refetch())
                  }
                />
              </td>
            ),
          }}
        />
      </CCard>
    </>
  );
};

export default ManageDynamicLinks;
